import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import {
  Text, Icon, colors,
} from 'react-orange-ui';

const Wrapper = styled.li`
  list-style-type: none;
  background-color: ${colors.grey6};
  height: 3rem;
  width: 100%;
  margin: 0.5rem 0;
`;

const WrapperLink = styled(Link)`
  padding: 1rem;
  display: flex;
  align-items: center;
  width: 100%;
  height: 3rem;
  text-decoration: none;
  
  &:focus {
    outline: ${colors.black} dotted 2px;
  }
  &:hover > p {
    color: ${colors.orange2};
  }
`;

const NoShrinkIcon = styled(Icon)`
  flex-shrink: 0;
`;

const TruncateText = styled(Text)`
  margin: 0 1rem;
  width: 100%;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ContactCard = (props) => {
  const {
    number,
    icon,
    label,
    onClick,
  } = props;

  const handleClick = (e) => {
    e.preventDefault();
    onClick();
  };

  return (
    <Wrapper id={`contact-card-${number}`}>
      <WrapperLink id={`contact-link-${number}`} to={{ pathname: '/otc' }} tabIndex="0" onClick={handleClick}>
        <NoShrinkIcon id={`icon-${icon}-contact-${number}`} icon={icon} width={24} height={24} color="black" aria-hidden="true" />
        <TruncateText bold id={`label-contact-${number}`}>
          {label}
        </TruncateText>
        <NoShrinkIcon id={`select-icon-contact-${number}`} icon="arrow-down" width={18} height={18} color="black" rotate={-90} />
      </WrapperLink>
    </Wrapper>
  );
};

ContactCard.defaultProps = {};

ContactCard.propTypes = {
  /** Function handler on click */
  onClick: PropTypes.func.isRequired,
  /** String icon name */
  icon: PropTypes.string.isRequired,
  /** String contact label */
  label: PropTypes.string.isRequired,
  /** Number contact */
  number: PropTypes.number
};

export default ContactCard;